import { render } from "./QuizDashboardPanel.vue?vue&type=template&id=45adeef1"
import script from "./QuizDashboardPanel.vue?vue&type=script&lang=js"
export * from "./QuizDashboardPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__